'use client';

import { SignIn } from '@clerk/clerk-react';
import { authClerkAppearance } from '../appearance';

const loginClerkAppearance = {
  ...authClerkAppearance,
  elements: {
    ...authClerkAppearance.elements,
    footerAction: 'hidden!',
    footerActionText: 'hidden!',
    footerActionLink: 'hidden!',
  },
} as const;

export default function LoginPage() {
  return (
    <div data-auth-login className="w-full">
      <SignIn
        path="/login"
        routing="path"
        appearance={loginClerkAppearance}
      />
    </div>
  );
}
